import React from 'react';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export const PrivacyPolicy = () => {
    const { t } = useTranslation(['common']);

    return <Container>
        <h1>{t('privacyPolicy.title', { ns: 'common' })}</h1>

        <h2>{t('privacyPolicy.howDoWeAccesYourData.title', { ns: 'common' })}</h2>
        <p>{t('privacyPolicy.howDoWeAccesYourData.text1', { ns: 'common' })}</p>

        <h2>{t('privacyPolicy.howDoWeUseYourData.title', { ns: 'common' })}</h2>
        <p>{t('privacyPolicy.howDoWeUseYourData.text1', { ns: 'common' })}</p>
        <ul>
            <li>{t('privacyPolicy.howDoWeUseYourData.list1.item1', {ns: 'common' })}</li>
            <li>{t('privacyPolicy.howDoWeUseYourData.list1.item2', { ns: 'common' })}</li>
            <li>{t('privacyPolicy.howDoWeUseYourData.list1.item3', { ns: 'common' })}</li>
            <li>{t('privacyPolicy.howDoWeUseYourData.list1.item4', { ns: 'common' })}</li>
        </ul>
        <h2>{t('privacyPolicy.howDoWeStoreYourData.title', { ns: 'common' })}</h2>
        <p>{t('privacyPolicy.howDoWeStoreYourData.text1', { ns: 'common', supportEmail: 'support@eventful.se' })}</p>

        <h2>{t('privacyPolicy.howDoWeShareYourData.title', { ns: 'common' })}</h2>
        <p>{t('privacyPolicy.howDoWeShareYourData.text1', { ns: 'common' })}</p>
    </Container>
};